(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["testro-ar-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('testro-ar')) {
    const MV_SRC = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
    let mvPromise = null;
    const loadModelViewer = () => {
      if (customElements.get('model-viewer')) return Promise.resolve();
      if (!mvPromise) {
        mvPromise = new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.type = 'module';
          s.src = MV_SRC;
          s.onload = () => customElements.whenDefined('model-viewer').then(resolve);
          s.onerror = reject;
          document.head.appendChild(s);
        });
      }
      return mvPromise;
    };

    const isAndroid = /android/i.test(navigator.userAgent);
    // model-viewer AR açamazsa Android'de Scene Viewer'ı doğrudan aç
    const sceneViewerUrl = (src, title) => {
      const file = new URL(src, location.href).href;
      const fallback = encodeURIComponent(location.href);
      return 'intent://arvr.google.com/scene-viewer/1.0?file=' + encodeURIComponent(file) + '&mode=ar_preferred&title=' + encodeURIComponent(title || '') +
        '#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=' + fallback + ';end;';
    };

    class TestroAR extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector('.tx-arb__modal');
        this.launchBtn = this.querySelector('[data-tx-ar-launch]');
        this.querySelector('[data-tx-ar-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-tx-ar-close]').addEventListener('click', () => this.modal.close());
        this.launchBtn.addEventListener('click', () => this.launch());
        this.modal.addEventListener('click', (e) => { if (e.target === this.modal) this.modal.close(); });
      }
      launch() {
        const mv = this.modalViewer;
        // Önce pencereyi kapat: modal içindeyken AR görünümü açılamıyor
        if (this.modal.open) this.modal.close();
        if (mv && mv.canActivateAR) {
          mv.activateAR();
        } else if (isAndroid) {
          location.href = sceneViewerUrl(this.dataset.src, this.dataset.title);
        }
      }
      open() {
        // Önce pencere açılır (anında görsel geri bildirim), ağır yükleme bir sonraki karede başlar
        this.modal.showModal();
        if (this.modalViewer) return;
        requestAnimationFrame(() => setTimeout(() => {
          loadModelViewer().then(() => {
            const mv = document.createElement('model-viewer');
            ['camera-controls', 'auto-rotate', 'ar'].forEach((a) => mv.setAttribute(a, ''));
            mv.setAttribute('ar-modes', 'scene-viewer quick-look webxr');
            mv.setAttribute('ios-src', this.dataset.iosSrc);
            mv.setAttribute('ar-placement', 'floor');
            mv.setAttribute('ar-scale', 'auto');
            mv.setAttribute('src', this.dataset.src);
            mv.setAttribute('alt', this.dataset.title);
            mv.setAttribute('shadow-intensity', '1');
            mv.setAttribute('exposure', '1.1');
            mv.setAttribute('interaction-prompt', 'none');
            mv.setAttribute('camera-orbit', '25deg 80deg auto');
            mv.addEventListener('ar-status', (e) => {
              if (e.detail.status === 'failed' && isAndroid) location.href = sceneViewerUrl(this.dataset.src, this.dataset.title);
            });
            mv.addEventListener('load', () => {
              this.launchBtn.hidden = !(mv.canActivateAR || isAndroid);
              this.classList.toggle('can-ar', !!mv.canActivateAR);
            });
            this.querySelector('.tx-arb__viewer').appendChild(mv);
            this.modalViewer = mv;
          }).catch(() => {});
        }, 0));
      }
    }
    customElements.define('testro-ar', TestroAR);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["testro-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('testro-bundle')) {
    const parsePrice = (t) => {
      const clean = String(t || '').replace(/[^\d,.]/g, '');
      if (!clean) return 0;
      // "1.489" -> 1489 ; "1.078,50" -> 1078.5 ; "285,00" -> 285
      const norm = clean.includes(',') ? clean.replace(/\./g, '').replace(',', '.') : clean.replace(/\./g, '');
      return parseFloat(norm) || 0;
    };
    const fmt = (n, cur) => n.toLocaleString('tr-TR', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' ' + (cur || 'TL');

    class TestroBundle extends HTMLElement {
      connectedCallback() {
        this.form = null;
        this.addEventListener('change', (e) => {
          if (e.target.matches('.tx-bundle__radio')) this.apply(e.target.value);
          this.total(true);
        });
        const fromUrl = new URLSearchParams(location.search).get('paket');
        if (fromUrl) {
          const r = this.querySelector('.tx-bundle__radio[value="' + parseInt(fromUrl, 10) + '"]');
          if (r) r.checked = true;
        }
        const checked = this.querySelector('.tx-bundle__radio:checked');
        requestAnimationFrame(() => {
          this.apply(checked ? checked.value : this.dataset.default || 1);
          this.total(false);
        });
        // Kahve sepete eklendikten sonra seçili aksesuarları ekle
        this.onCart = (event) => this.handleCart(event);
        document.addEventListener('shopify:cart:lines-update', this.onCart);
        // Çekmeceyi tema hemen açmasın: direkt ödemede hiç açılmaz, normalde uçma animasyonundan sonra biz açarız
        document.querySelectorAll('cart-drawer-component[auto-open]').forEach((d) => d.removeAttribute('auto-open'));
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:cart:lines-update', this.onCart);
      }
      scope() {
        return this.closest('.product-information, product-information, section') || document;
      }
      apply(qty) {
        this.scope().querySelectorAll('input[name="quantity"]').forEach((input) => {
          input.value = qty;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      total(bump) {
        const radio = this.querySelector('.tx-bundle__radio:checked');
        let sum = radio ? parsePrice(radio.dataset.price) : 0;
        this.querySelectorAll('.tx-bundle__check:checked').forEach((c) => (sum += parseFloat(c.dataset.priceNum) || 0));
        const el = this.querySelector('[data-tx-total]');
        if (!el) return;
        el.textContent = fmt(sum, this.dataset.currency);
        if (bump) {
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
        }
      }
      // Paket görseli sepet ikonuna uçar, ikon zıplar, sonra çekmece kayarak açılır
      async openDrawer(startedAt) {
        const fly = document.querySelector('fly-to-cart');
        if (fly) await Promise.allSettled(fly.getAnimations().map((a) => a.finished));
        const wait = 750 - (performance.now() - startedAt);
        if (wait > 0) await new Promise((r) => setTimeout(r, wait));
        const icon = document.querySelector('.header-actions__cart-icon');
        if (icon) {
          icon.classList.remove('tx-cart-bump');
          void icon.offsetWidth;
          icon.classList.add('tx-cart-bump');
          await new Promise((r) => setTimeout(r, 380));
        }
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (drawer && !drawer.isOpen) drawer.open();
      }
      handleCart(event) {
        const action = event.action ?? event.detail?.action;
        const context = event.context ?? event.detail?.context;
        if (this.busy || context === 'testro-addon') return;
        if (action && action !== 'add') return;
        const target = event.target;
        if (!(target instanceof Node) || !this.scope().contains(target)) return;
        const ids = Array.from(this.querySelectorAll('.tx-bundle__check:checked')).map((c) => ({ id: Number(c.value), quantity: 1 }));
        const direct = this.hasAttribute('data-direct');
        if (!event.promise) return;
        const startedAt = performance.now();
        this.busy = true;
        let failed = false;
        event.promise
          .then((res) => {
            if (res?.detail?.didError) { failed = true; throw new Error('add'); }
            if (!ids.length) return null;
            return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: ids }),
            }).then((r) => r.json());
          }, () => { failed = true; throw new Error('add'); })
          .then(() => {
            if (direct) {
              location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout';
              return null;
            }
            return import('@shopify/events');
          })
          .then((mod) => {
            if (!mod) return;
            if (!ids.length) return this.openDrawer(startedAt);
            const { CartLinesUpdateEvent } = mod;
            const deferred = CartLinesUpdateEvent.createPromise();
            document.dispatchEvent(new CartLinesUpdateEvent({
              action: 'add',
              context: 'testro-addon',
              lines: ids.map((i) => ({ merchandiseId: String(i.id), quantity: 1 })),
              promise: deferred.promise,
            }));
            deferred.resolve({ detail: {} });
            return this.openDrawer(startedAt);
          })
          .catch(() => {
            // Sepete ekleme hata verdiyse sayfada kal; aksesuar eklenemediyse yine de ödemeye geç / çekmeceyi aç
            if (failed) return;
            if (direct) location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout';
            else this.openDrawer(startedAt);
          })
          .finally(() => {
            this.busy = false;
            this.querySelectorAll('.tx-bundle__check:checked').forEach((c) => (c.checked = false));
            this.total(false);
          });
      }
    }
    customElements.define('testro-bundle', TestroBundle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["testro-icerik"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('testro-icerik')) {
    class TestroIcerik extends HTMLElement {
      connectedCallback() {
        const modal = this.querySelector('.tx-ic__modal');
        this.querySelector('[data-tx-ic-open]').addEventListener('click', () => modal.showModal());
        this.querySelectorAll('[data-tx-ic-close]').forEach((b) => b.addEventListener('click', () => modal.close()));
        modal.addEventListener('click', (e) => { if (e.target === modal) modal.close(); });
      }
    }
    customElements.define('testro-icerik', TestroIcerik);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["testro-link-kart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a.tx-lk[href^="#"]');
    if (!a) return;
    const target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
